export const textStyled = {
    styleOverrides: {
        root: {
            color: "#4F4F56",
            fontFamily: "'Montserrat', 'Montserrat Fallback', sans-serif",
            fontSize: 14,
            "& h1": {
                fontFamily: "'Montserrat', 'Montserrat Fallback', sans-serif",
                fontSize: "28px",
                lineHeight: "120%",
                fontWeight: 500,
                "@media (min-width:1200px)": {
                    margin: 0,
                    fontSize: "36px",
                },
                "@media (min-width:1440px)": {
                    margin: 0,
                    fontSize: "40px",
                },
            },
            "& h2": {
                fontFamily: "'Montserrat', 'Montserrat Fallback', sans-serif",
                fontWeight: 400,
                fontSize: "16px",
                lineHeight: "160%",
                "@media (min-width:600px)": {
                    fontSize: "28px", // Desktop up
                },
            },
            "& h3": {
                fontFamily: "'Montserrat', 'Montserrat Fallback', sans-serif",
                fontWeight: 700,
                fontSize: "24px",
                lineHeight: "130%",
                letterSpacing: "0.02em",
                "@media (min-width:600px)": {
                    fontSize: "24px", // Desktop up
                },
            },
            "& h4": {
                fontFamily: "'Montserrat', 'Montserrat Fallback', sans-serif",
                fontWeight: 700,
                fontSize: "20px",
                lineHeight: "130%",
                letterSpacing: "0.02em",
                "@media (min-width:600px)": {
                    fontSize: "24px", // Desktop up
                },
            },
            "& h5": {
                fontFamily: "'Montserrat', 'Montserrat Fallback', sans-serif",
                fontWeight: 700,
                fontSize: "18px",
                lineHeight: "135%",
                letterSpacing: "0.02em",
                "@media (min-width:600px)": {
                    fontSize: "20px", // Desktop up
                },
            },
            "& h6": {
                fontFamily: "'Montserrat', 'Montserrat Fallback', sans-serif",
                fontWeight: 700,
                fontSize: "16px",
                lineHeight: "140%",
                letterSpacing: "0.02em",
            },
            "& a": {
                color: "primary.main",
                fontWeight: 600,
                textDecoration: "none",
            },
            "& p": {
                margin: 0,
                fontFamily: "'Montserrat', 'Montserrat Fallback', sans-serif",
                fontWeight: 400,
                fontSize: "16px",
                lineHeight: "160%",
            },
            "& pre": {
                whiteSpace: "pre-wrap",
            },
            // Surcharge des listes à puces pour avoir un carré de couleur
            "& ul:not(.todo-list)": {
                listStyle: "none",
                pl: 0,
                ml: 0,
                "& li": {
                    listStyle: "none",
                    textIndent: "-14px",
                    pl: "14px",
                    "@media (max-width:900px)": {
                        pl: "22px",
                    },
                    "&:not(:last-child)": {
                        mb: 1.5,
                    },
                    "& .ck-list-bogus-paragraph": {
                        display: "inline",
                    },
                    "&::before": {
                        content: '""',
                        display: "inline-block",
                        width: "10px",
                        height: "10px",
                        marginTop: "-2px",
                        backgroundColor: "#0000FF",
                        marginRight: "12px",
                        verticalAlign: "middle",
                        flexShrink: 0,
                    },
                },
            },
            "&  ul.todo-list": {
                listStyle: "none",
                pl: "22px",
                "& li": {
                    listStyle: "none",
                    textIndent: "-22px",
                    "&:not(:last-child)": {
                        mb: 1.5,
                    },
                    "&:before": {
                        content: `"\\f00c"`,
                        fontWeight: "400",
                        fontSize: "14px",
                        verticalAlign: "middle",
                        textIndent: "0",
                        width: "22px",
                        display: "inline-block",
                        fontFamily: `"Font Awesome 5 Pro"`,
                        color: "#007F00",
                    },
                    "& ul": {
                        ml: 3,
                        "& li": {
                            textIndent: "-22px",
                            "&:before": {
                                content: `"\\f00c"`,
                                fontWeight: "400",
                                fontSize: "14px",
                                width: "22px",
                                color: "secondary.main",
                            },
                        },
                    },
                },
            },
        },
    },
};
